import { render, staticRenderFns } from "./PrescricoesPorData.vue?vue&type=template&id=28c55ef7&"
import script from "./PrescricoesPorData.vue?vue&type=script&lang=js&"
export * from "./PrescricoesPorData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports